module.exports = __webpack_public_path__ + "img/pie_chart_icon.ff09cdac.svg";